export default __webpack_public_path__ + "static/media/banner311.a2dd4c27.webp";